export interface IProductionResponse {
  systemId: number;
  monitoringIdentificationCode: string;
  fromDate: Date;
  toDate: Date;
  production: number;
  apiResponse: string;
  messages: string[];
  hasDateRangeOffset: boolean;
  unit: string;
}

export class ProductionResponse implements IProductionResponse {
  systemId: number;
  monitoringIdentificationCode: string;
  fromDate: Date;
  toDate: Date;
  production: number;
  apiResponse: string;
  messages: string[];
  hasDateRangeOffset: boolean;
  unit: string;
}